// Copyright (c) 2016 Deere & Companypins

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {createResponsibleDealer} from '../../shared/repositories';
import {openFile} from '../../../shared/services/open-file';

export const createResponsibleReport = exportToExcel =>
    async(dispatch, getState) => {

        dispatch(busyCounter.increaseBusyCounter());

        const responsibleDealerReportState = getState().reports.responsibleDealer;

        const reportCriteria = {
            accounts: responsibleDealerReportState.selectedDealers.map(dealer => dealer.account),
            ...responsibleDealerReportState.criteria
        };

        try {

            const data = await createResponsibleDealer(reportCriteria, exportToExcel);

            if (exportToExcel) {

                const fileName = `Responsible-dealer-${new Date()}`;

                const blob = await data.blob();

                openFile(blob, fileName, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');

            } else {

                dispatch({
                    data,
                    type: actions.CREATE_RESPONSIBLE_DEALER_REPORT_SUCCESS
                });

                dispatch({
                    hasNoResult: data.length < 1,
                    type: actions.UPDATE_SHOW_NO_RESULTS_FOUND
                });

            }

        } catch (error) {

            dispatch({
                hasNoResult: false,
                type: actions.UPDATE_SHOW_NO_RESULTS_FOUND
            });

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };

export const exortExcelResponsibleDealerReport = () =>
        async(dispatch, getState) => {

            dispatch(busyCounter.increaseBusyCounter());

            const responsibleDealerReportDealerState = getState().reports.responsibleDealer;

            const reportCriteria = {
                accounts: responsibleDealerReportDealerState.selectedDealers.map(dealer => dealer.account),
                ...responsibleDealerReportDealerState.criteria
            };

            try {

                const data = await createResponsibleDealer(reportCriteria);

                dispatch({
                    data,
                    type: actions.CREATE_RESPONSIBLE_DEALER_REPORT_SUCCESS
                });

                dispatch({
                    hasNoResult: data.length < 1,
                    type: actions.UPDATE_SHOW_NO_RESULTS_FOUND
                });

            } catch (error) {

                dispatch({
                    hasNoResult: false,
                    type: actions.UPDATE_SHOW_NO_RESULTS_FOUND
                });

            } finally {

                dispatch(busyCounter.decreaseBusyCounter());

            }

        };



// WEBPACK FOOTER //
// ./src/reports/responsible-dealer/action-creators/create-report.js